import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DateUtils, StringUtils, ArrayUtils } from '../utils';
import '../css/FrontDesk.css';

import { History as history, Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ConsultationsActions } from '../actions';
import { TitleBar, NavBar, LinkedPractices, PracticeProfile, ConsultationsResolved, ConsultationsActive, StartConsultation } from  '../components'

class FrontDeskHomeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayingCompleted: false,
      expandedTaskId: '',
    }
  }

  componentDidMount() {
    const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    if (token) {
      this.props.practiceActions.getFrontDeskUserTasks(token);
    }
  }

  renderTaskRow = (task) => {
    if (!task) {
      return null;
    }

    const expanded = task._id === this.state.expandedTaskId ? true : false;
    const consultation = this.props.consultations && this.props.consultations.allConsultations ? this.props.consultations.allConsultations[task.consultation_id] : {};
    const assginer = this.props.user && this.props.user.users[task.assigner] ? this.props.user.users[task.assigner] : {};
    let   client   = consultation && this.props.user && consultation.primary_client ? this.props.user.users[consultation.primary_client] : {};
    const patient  = this.props.practice && this.props.practice.patients && consultation && consultation.patient_id && this.props.practice.patients[consultation.patient_id] ? this.props.practice.patients[consultation.patient_id] : {};
    const shortMsg = task.message.length > 120 ? task.message.substr(0,119) + '...' : task.message;
    const completed= task.completed;
    const displayOpenConsultation = consultation && consultation._id ? true : false;

    if (consultation && consultation.client && ArrayUtils.getSingleObject(consultation.client)) {
      client = ArrayUtils.getSingleObject(consultation.client);
    }

    return <div className="flex-container-column" style={{ marginTop: 5 }}>
      <div className="flex-container-row">
        <div style={{ flex: 0.8 }}>
          <span style={{ fontSize: 14, color: '#575757' }}>{ StringUtils.displayName(assginer) }</span>
        </div>
        <div style={{ flex: 0.8 }}>
          <span style={{ fontSize: 14, color: '#575757' }}>{ task.subject }</span>
        </div>
        <div style={{ flex: 2 }}>
          <span style={{ fontSize: 14, color: 'grey' }}>{ expanded ? task.message : shortMsg }</span>
        </div>
        <div className='flex-container' style={{ flex: 0.4, alignItems: 'flex-start', justifyContent: 'center' }}>
          <div className='flex-container button-clear-blue'
               style={{ padding: 5, alignItems: 'center', justifyContent: 'center', height: 40, width: 40, borderRadius: 20 }}
               onClick={ () => { this.setState({ ...this.state, expandedTaskId: expanded ? '' : task._id }) }}>
            <span className={ expanded ? "fas fa-minus" : "fas fa-plus" } style={{ fontSize: 24, color: '#1dc2ff' }}></span>
          </div>
        </div>
      </div>

      { expanded
      ? <div className='flex-container-row' style={{ marginTop: 5 }}>
            <div className='flex-container-column' style={{ flex: 0.8 }}>
              <span style={{ fontSize: 14 }}>{ StringUtils.displayName(client) }</span>
              <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>{ 'CLIENT' }</span>
            </div>
            <div className='flex-container-column' style={{ flex: 0.8 }}>
              <span style={{ fontSize: 14 }}>{ patient.name }</span>
              <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>{ 'ANIMAL' }</span>
            </div>
            <div className='flex-container-column' style={{ flex: 2 }}>
              <span style={{ fontSize: 14 }}>{ consultation.subject }</span>
              <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>{ 'CONSULTATION' }</span>
            </div>
            <div className='flex-container' style={{ flex: 0.4, alignItems: 'flex-start', justifyContent: 'center' }}>
            </div>
        </div>
      : null }

      { expanded
      ? <div style={{ marginTop: 5 }}>
          <div className="flex-container-row">
            <div className='flex-container-column' style={{ flex: 2.51 }}></div>
            <div className='flex-container-column' style={{ flex: 0.8 }}>
              <div>
                { displayOpenConsultation ? <input type='submit'
                                               className='button-clear-blue'
                                               value='View Consultation'
                                               style={{ marginRight: 20, borderWidth: 1, borderColor: '#e7e7e7' }}
                                               onClick={ () => {
                                                 const token = this.props.user.auth.token;
                                                 this.props.consultationsActions.openConsultation(token, consultation)
                                               }}
                                              /> : null }
              </div>
            </div>
            <div className='flex-container' style={{ flex: 0.4, alignItems: 'flex-start', justifyContent: 'center' }}>
            </div>
            <div className='flex-container-row' style={{ flex: 2, justifyContent: 'flex-end', alignItems: 'center' }}>
              { completed ? null : <input type='submit'
                     className='button-default'
                     value='Completed'
                     style={{ marginRight: 20 }}
                     onClick={ () => {
                       const token = this.props.user.auth.token;
                       this.props.practiceActions.completeFrontDeskTask(token, task);
                       this.setState({ ...this.state, expandedTaskId: '' });
                     }}
                    /> }
            </div>
          </div>
        </div>
      : null }

    </div>
  }

  renderTaskRows = (tasks) => {
    const orderedTasks = tasks.sort((a, b) => { return DateUtils.getDateTime(b.created_at) - DateUtils.getDateTime(a.created_at) })
                              .filter((tsk) => {
                                if (this.state.displayingCompleted) {
                                  return tsk.completed === true
                                } else {
                                  return tsk.completed !== true
                                }
                              });

    if (orderedTasks.length === 0) {
      const emptyMessage = this.state.displayingCompleted ? 'There are no Completed tasks' : 'There are no Open tasks';
      return <div className='flex-container-row' style={{ padding: 20, paddingBottom: 30, justifyContent: 'center', alignItems: 'center' }}>
        <span style={{ color: 'grey', fontSize: 15 }}>{ emptyMessage }</span>
      </div>;
    }

    const taskRows = orderedTasks.map((task, index) => {
      const isLast = index + 1 === orderedTasks.length;
      return <div key={task._id}>

        { this.renderTaskRow(task) }
        { !isLast ? <div style={{ backgroundColor: '#e7e7e7', height: 1, marginTop: 15, marginBottom: 15 }}></div> : null }
      </div>
    }).filter((row) => { return row });

    return <div>
      { taskRows }
    </div>
  }

  renderFrontDeskHomeContent = () => {

    const getLocationObj = this.getCurrentLocation();
    const locationName   = getLocationObj && getLocationObj.name ? getLocationObj.name : '';
    const frontDeskTasks = this.props.practice && this.props.practice.frontDeskTasks ? this.props.practice.frontDeskTasks : [];

    return <div className="flex-container-column" style={{ }}>
        <div className="front-desk-tasks-container" style={{ borderRadius: 10 }}>

          <div className="flex-container-row" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div className="flex-container-column">
              <span style={{ marginBottom: 2, fontSize: 20, color: '#575757' }}>{ this.state.displayingCompleted ? 'Completed Tasks' : 'Front Desk Tasks' }</span>
              <span style={{ fontSize: 14, color: 'grey', marginTop: -5 }}>{ locationName }</span>
            </div>
            <div className="flex-container-column flex-center-justify">
            <input  type="submit"
                    value={ this.state.displayingCompleted ? 'VIEW OPEN TASKS' : 'VIEW COMPLETED TASKS' }
                    className="button-clear-blue"
                    onClick={ () => {
                      this.setState({ ...this.state, displayingCompleted: !this.state.displayingCompleted });
                    }}
                  />
            </div>
          </div>

          { this.renderTaskRows(frontDeskTasks) }

        </div>
      </div>
  }

  renderStartConsultationSection = () => {
    return <div className='flex-container-row' style={{ marginTop: 15, alignItems: 'center' }}>
       <div className='standard-container flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', width: 800, maxWidth: 800, padding: 15  }}>
        <div className='flex-container-column'>
          <span style={{ fontSize: 20, color: '#575757' }}>Start a new Consultation</span>
          <span style={{ color: 'grey', fontSize: 14 }}>Select a client, patient and provider to start a consultation for.</span>
        </div>
        <div className='flex-container-column'>
          <div className='button-default'
               style={{ padding: 18, paddingRight: 25, paddingLeft: 25, borderRadius: 5 }}
               onClick={ () => {
                 history.push(routes.CONSULTATION_START);
               }}>
            <span style={{ color: 'white', fontSize: 12, letterSpacing: 0.8 }}>START CONSULTATION</span>
          </div>
        </div>
      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          currentRoute={routes.FRONT_DESK_HOME}
          practice={this.props.practice.practice}
        />

        { this.renderStartConsultationSection() }
        { this.renderFrontDeskHomeContent()     }

      </div>
    );
  }

  getCurrentLocation = () => {
    const frontDeskUsers = this.props.practice && this.props.practice.frontDeskUsers ? this.props.practice.frontDeskUsers : [];
    const currentUserId  = this.props.user.auth.user_id || '';
    const allLocations   = this.props.practice.locations || {};

    var currentLocation  = null;

    if (frontDeskUsers.length > 0 && currentUserId) {
      frontDeskUsers.forEach((user) => {
        const locationID = user.location_id;
        const location   = allLocations[locationID];
        if (user.user_id === currentUserId) {
          currentLocation = location;
        }
      });
    }

    return currentLocation;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    consultations: state.consultations,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
   consultationsActions: bindActionCreators(
    { ...ConsultationsActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FrontDeskHomeScreen)
